export default __webpack_public_path__ + "static/media/calendar.c60154f5.svg";